export const sidebarStructure = {
  home: {
    title: 'Home',
    route: '/',
    children: {



      about: {
        title: 'About',
        route: '/about',
      },



      tools: {
        title: 'Tools',
        redirectToFirstChild: true,
        children: {
          timer: {
            title: 'Basic Countdown ',
            route: '/tools/timer',
          },
          onerepmax: {
            title: 'One Rep Max Estimator',
            route: '/tools/onerepmax',
          },
          proteinintake: {
            title: 'Protein Intake Calculator',
            route: '/tools/proteinintake',
          },


          reminders: {
            title: 'SweatText SMS Reminders',
            // redirectToFirstChild: true,
            route: '/tools/reminders/dashboard',

            // children: {
              // info: {
              //   title: 'ℹ️ Info',
              //   route: '/tools/reminders/info',
              // },
              // sweattextsetup: {
              //   'title': 'Setup For Trainers',

              //   redirectToFirstChild: true,
              //   children: {

              //     step1: {
              //       title: 'Step 1: Trainer Log In',
              //       route: '/tools/reminders/step1',
              //     },
              //     step2: {
              //       title: 'Step 2:  Enter Name ',
              //       route: '/tools/reminders/step2',
              //     },
              //     step3: {
              //       title: 'Step 3: Customize Text ',
              //       route: '/tools/reminders/step3',
              //     },
              //     step4: {
              //       title: 'Step 4:Specify Schedule',
              //       route: '/tools/reminders/step4',
              //     },
              //     step5: {
              //       title: 'Step 5: Activate',
              //       route: '/tools/reminders/step5',
              //     },
              //     step6: {
              //       title: 'Step 6: Validate',
              //       route: '/tools/reminders/step6',
              //     },
              //   }

              // },
              // sweattextdashboard: {
              //   title: 'Dashboard',
              //   route: '/tools/reminders/dashboard',
              // },
              // optIn: {
              //   title: 'Client SMS Opt-In',
              //   route: '/opt-in',
              // },
              // optInConfirmed: {
              //   title: 'Opt-In Confirmation',
              //   route: '/opt-in/confirmed',
              // },
            // },
          },

          
        },
      },


      account: {
        title: 'Account',
        route: '/settings',
        hideIfNotAuthenticated: true,
        children: {
          manageAccount: {
            title: 'Manage Account',
            route: '/settings/account',
          },
          subscription: {
            title: 'Subscription',
            route: '/settings/subscription',
          },
          hourlyRate: {
            title: 'Hourly Rate',
            route: '/settings/hourly-rate',
          },
          notifications: {
            title: 'Notifications',
            route: '/settings/notifications',
          },
          privacy: {
            title: 'Privacy',
            route: '/settings/privacy',
          },
          logout: {
            title: 'Logout',
            route: '/settings/logout',
          },
        },
      },






      tooldemos: {
        title: 'Unfinished Tool Demos',
        redirectToFirstChild: true,
        children: {
          fittracker: {
            title: '🧠 FitTracker ',
            redirectToFirstChild: true,
            children: {
              dashboard: {
                title: 'Dashboard',
                route: '/clients/example/dashboard',
              },
              profile: {
                title: 'Goals',
                route: '/clients/example/profile',
              }
            },
          },
          clientmanager: {
            title: 'Client and Trainer Finder ',
            redirectToFirstChild: true,
            children: {
              trainerprofile: {
                title: 'Trainer Profile',
                route: '/profile'
              },
              trainerdirectory: {
                title: 'Trainer Search',
                route: '/trainerssearch'
              },
              clientlist: {
                title: 'My Clients',
                route: '/clientlist'
              }
            },
          },
          scheduler: {
            title: '🗓️ Session Scheduling Tool ',
            redirectToFirstChild: true,
            children: {
              regenerate: {
                title: 'Generate More Sessions',
                route: '/clients/example/regenerate',
              },
              availability: {
                title: 'Scheduling Availability',
                route: '/clients/example/schedulingavailability',
              },
              schedule: {
                title: 'Schedule',
                route: '/clients/example/queue',
              },
            },
          },
          executeWorkoutSession: {
            title: 'Guided Workout Tool ',
            route: '/clients/example/executeworkoutsession',
          },
          workoutprogramming: {
            title: '📊 Workout Programming Tool ',
            redirectToFirstChild: true,
            children: {
              workoutlibrary: {
                title: 'Workout Library',
                route: '/workoutlibrary',
              },
              exerciseDetail: {
                title: 'Exercise Detail',
                route: '/workouts/squat',
              },
            },
          },
          messages: {
            title: '💬 Messaging Tool ',
            route: '/messages',
          },
          payments: {
            title: '💰 Payments Tool ',
            route: '/clients/example/payments',
          },
        },
      },




      



      articles: {
        title: 'News',
        redirectToFirstChild: true,
        children: {

          proteinIntakeReleasedArticle: {
            title: 'Protein Intake Calculator Released',
            route: '/articles/4',
          },
          article3: {
            title: 'What’s the Deal with Rest Timers...',
            route: '/articles/3',
          },
          article2: {
            title: 'What Is a One Rep Max...',
            route: '/articles/2',
          },
          article1: {
            title: 'The Psychology of Showing Up...',
            route: '/articles/1',
          },
          sweattextDemoArticle: {
            title: 'SweatText Demo Released',
            route: '/news/3',
          },
          timerToolsArticle: {
            title: 'Timer & One Rep Max Tools Available!',
            route: '/news/2',
          },
          demoPlatformArticle: {
            title: 'Demo Platform Released',
            route: '/news/1',
          },
        },
      },



      login: {
        title: 'Log In',
        route: '/login',
        hideIfAuthenticated: true,
      },
      // tour: {
      //   title: '🧭 Take a Tour',
      //   route: '/tour',
      // },
      privacyPolicy: {
        title: 'Privacy Policy',
        route: '/privacy',
      },
      termsOfUse: {
        title: 'Terms of Use',
        route: '/terms',
      },
      contact: {
        title: 'Contact',
        route: '/contact',
      },
    },
  },
};

// Helper to recursively collect all routes under a node
export function collectRoutes(node) {
  let routes = [];
  if (node.route) {
    routes.push(node.route);
  }
  if (node.children) {
    for (const key in node.children) {
      routes = routes.concat(collectRoutes(node.children[key]));
    }
  }
  return routes;
}
